[].slice.call(document.querySelectorAll('#hero, section.testimonials')).forEach(function(section) {
	[].slice.call(section.querySelectorAll('button')).forEach(function(button) {
		button.addEventListener('click', function() {
			setSliderInterval(section, this.className);
		});
	});
});

document.addEventListener('keydown', function(e) {
	var activeElement = document.activeElement;

	if(activeElement.classList.contains('prev') || activeElement.classList.contains('next')) {
		var key = e.key,
			direction = key == 'ArrowRight' ? 'next' : (key == 'ArrowLeft' ? 'prev' : ''),
			section = hero.contains(activeElement) ? hero : (testimonialsSection.contains(activeElement) ? testimonialsSection : false);

		if(direction && section) {
			setSliderInterval(section, direction);
			section.querySelector('button.'+direction).focus();
		}
	}
});

function setSliderInterval(section, direction) {
	if(section == hero) {
		setCurrentSlide(direction == 'next');
		clearInterval(slidesInterval);
		slidesInterval = setInterval(autoSlideHero, 7000);
	}
	else if(section == testimonialsSection) {
		setCurrentTestimonial(direction == 'next');
		clearInterval(testimonialsInterval);
		testimonialsInterval = setInterval(autoSlideTestimonials, 7000);
	}
}